<div
  class="gatewee-checkbox-root gw-flex gw-items-center gw-gap-[8px]"
  [class.checkbox-size-s]="size === 's'"
>
  <div
    class="checkbox-box gw-border-base gw-cursor-pointer"
    [class.active]="value"
    [class.indeterminate]="indeterminate && !value"
    [class.disabled]="disabled"
    (click)="activate($event)"
  >
    <span *ngIf="value" class="check">✓</span>
    <span *ngIf="indeterminate && !value" class="check">–</span>
  </div>

  <label
    *ngIf="label"
    [attr.for]="checkboxId"
    class="gw-text-text-secondary gw-cursor-pointer"
    [style.font-size.px]="labelFontSizePx"
  >
    {{ label }}
  </label>

  <input
    type="checkbox"
    class="gw-hidden"
    [attr.id]="checkboxId"
    [checked]="value"
    [disabled]="disabled"
    (change)="onNativeInputChange($event)"
  />
</div>
